import { ref, remove } from "firebase/database";
import { database } from "../../Utils/firebase";


const RemoveFromDeletedNode = async (userId) => {
    if (!userId) return null;

    try {
        const nodeRef = ref(database, `invoiceGenerator/deletedUsers/${userId}`);

        remove(nodeRef)
            .then(() => {
                console.log("Node deleted successfully");
            })
            .catch((error) => {
                console.error("Error deleting node:", error);
            });
        return true;
    } catch (error) {
        console.error("Error fetching user data:", error);
        return null;
    }
};

export default RemoveFromDeletedNode;





